import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import {
  MiniCardShape,
  MiniCardViewContent,
  MiniCardViewUIConfiguration,
  UserUiSettings,
  flattenEntry,
} from '@osos/shared/legacy-core';
import {
  CounterUserEntryPresenterModel,
  DataEntityPresenterModel,
  DataEntryPresenterModel,
} from '@osos/shared/types';

export interface MiniCardEntryData {
  id: number;
  mainTitle: string;
  subTitle: string;
  date: string;
  icon: string;
  isEntryObsolete: boolean;
  isIncludedInQueryResult: boolean;
}

@Component({
  selector: 'app-mini-card-view',
  templateUrl: './mini-card-view.component.html',
  styleUrls: ['./mini-card-view.component.scss'],
  standalone: false,
})
export class MiniCardViewComponent implements OnInit, OnChanges {
  @Input() entries: CounterUserEntryPresenterModel[] = [];
  @Input() miniCardConfig: MiniCardViewUIConfiguration;
  @Input() entity: DataEntityPresenterModel;
  @Input() totalCount: number;
  @Input() loading;
  @Output() scrollEvent: EventEmitter<number> = new EventEmitter();
  @Output() clickEvent: EventEmitter<DataEntryPresenterModel> =
    new EventEmitter();
  cardViewEntries: MiniCardEntryData[];
  miniCardShape: MiniCardShape;
  constructor(private _userUiSettings: UserUiSettings) {
    this.cardViewEntries = [];
  }

  ngOnInit() {}
  ngOnChanges(changes) {
    if (
      changes.entries &&
      this.miniCardConfig &&
      !changes.entries.firstChange
    ) {
      this.initMiniCardView();
    }
  }

  initMiniCardView(): void {
    const miniCardView = new MiniCardViewContent(
      this.miniCardConfig.displyedFields,
    );

    this.miniCardShape = miniCardView.getCardShape() as MiniCardShape;

    this.cardViewEntries = this.cardViewEntries.concat(
      this.entries.map((entry, index) => {
        const flattenedEntry = flattenEntry(entry, this.entity);
        return {
          id: index,
          mainTitle:
            flattenedEntry[this.miniCardShape.mainTitle?._normalizedName],
          subTitle:
            flattenedEntry[this.miniCardShape.subTitle?._normalizedName],
          date: flattenedEntry[this.miniCardShape.date?._normalizedName],
          icon: flattenedEntry[this.miniCardShape.picture?._normalizedName],
          isEntryObsolete: entry.isEntryObsolete,
          isIncludedInQueryResult: entry.isIncludedInQueryResult,
        };
      }),
    );
  }
  trackByFn(index: number): number {
    return index;
  }
  onScroll() {
    if (!this.loading && this.cardViewEntries.length < this.totalCount) {
      this.scrollEvent.emit(this.cardViewEntries.length);
    }
  }
  onclick(item: MiniCardEntryData) {
    this.clickEvent.emit(this.entries[item.id]);
  }
  get dateFormat(): string {
    return this._userUiSettings?.dateFormat ?? 'd MMM y';
  }
}
